var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34454 11.8571L11.6579 1.49707M1.34454 1.49707L11.6579 11.8571",
    stroke: "white",
    strokeWidth: 2.1875,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.8b6305ac312ff2586b80c7658a004d23.svg";
export { ForwardRef as ReactComponent };